module.exports = __webpack_public_path__ + "img/KSC01001.82d31f8c.jpg";